import { useContext } from 'react';
import { isUndefined } from 'lodash';

import { useParseParams } from '@hooks/params';
import { FilterContext, FilterType } from './context';
import { boolean, object } from 'yup';

export const useFilterContext = () => {
  const context = useContext(FilterContext);
  if (isUndefined(context)) throw new Error('useFilterContext must be used within a FilterProvider');
  return context;
};

const schema = object({
  ipd: boolean().default(false),
  opd: boolean().default(false),
  healthCheckup: boolean().default(false),
  dental: boolean().default(false),
  maternity: boolean().default(false),
  vision: boolean().default(false),
});

export const useFilterParams = () => useParseParams<FilterType>(schema);
